import React from 'react'
import cx from 'classnames'

import styles from './SequenceNumber.module.scss'

export const SequenceNumber = ({ sequenceNumber, isActive, isDisabled }) => (
  <span
    className={cx(styles.number, {
      [styles.active]: isActive,
      [styles.disabled]: isDisabled,
    })}
  >
    {sequenceNumber}
  </span>
)
